import { render, staticRenderFns } from "./classification-input.vue?vue&type=template&id=7f921e34"
import script from "./classification-input.vue?vue&type=script&lang=js"
export * from "./classification-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports